import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.css']
})
export class HowItWorksComponent implements AfterViewInit {
  private player: any;

  ngAfterViewInit(): void {
    this.loadYouTubeAPI();
  }

  // Load the YouTube IFrame API script dynamically
  private loadYouTubeAPI(): void {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

    // Assign the onYouTubeIframeAPIReady function to the window object
    (window as any).onYouTubeIframeAPIReady = () => {
      this.initializeYouTubePlayer();
    };
  }

  // Initialize the YouTube player
  private initializeYouTubePlayer(): void {
    this.player = new (window as any).YT.Player('youtube-video', {
      events: {
        onStateChange: this.onPlayerStateChange.bind(this),
      },
    });

    // Attach click listeners for features
    this.attachFeatureClickListeners();
  }

  // Handle the YouTube player state changes
  private onPlayerStateChange(event: any): void {
    if (event.data === (window as any).YT.PlayerState.PLAYING) {
      this.monitorPlaybackTime();
    }
  }

  // Monitor playback time and highlight text based on intervals
  private monitorPlaybackTime(): void {
    const intervals = [
      { time: 18, id: 'feature-1' },
      { time: 40, id: 'feature-2' },
      { time: 68, id: 'feature-3' },
      { time: 80.1, id: 'feature-4' },
    ];

    setInterval(() => {
      const currentTime = Math.floor(this.player.getCurrentTime());

      intervals.forEach((interval, index) => {
        const element = document.getElementById(interval.id);
        const nextTime = intervals[index + 1]?.time || Infinity; // Use Infinity for the last interval
        if (currentTime >= interval.time && currentTime < nextTime) {
          element?.classList.add('highlight');
        } else {
          element?.classList.remove('highlight');
        }
      });
    }, 1000); // Check every second
  }

  // Attach click listeners to feature items to jump to video playback time
  private attachFeatureClickListeners(): void {
    const intervals = [
      { time: 18, id: 'feature-1' },
      { time: 40, id: 'feature-2' },
      { time: 68, id: 'feature-3' },
      { time: 80.1, id: 'feature-4' },
    ];

    intervals.forEach(({ time, id }) => {
      const element = document.getElementById(id);
      element?.addEventListener('click', () => {
        this.player.seekTo(time, true); // Jump to the specific playback time
        this.player.playVideo(); // Play the video
      });
    });
  }
}
